import { render } from "./weighing.vue?vue&type=template&id=8e64d2dc"
import script from "./weighing.vue?vue&type=script&lang=js"
export * from "./weighing.vue?vue&type=script&lang=js"

import "./weighing.vue?vue&type=style&index=0&id=8e64d2dc&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__